export const AIFMOH_HOLDING = 'AIFMOH_HOLDING'
export const AIFMOH_HOLDING_RESPONSE = 'AIFMOH_HOLDING_RESPONSE'
export const AIFMOH_HOLDING_FAILED = 'AIFMOH_HOLDING_FAILED'